<div class="download-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      {{ isFast ? ('Saving eQuote in process' | translate) : ('COMMON.Downloading PDF...' | translate) }}
    </h2>
    <span class="close-icon" (click)="dialogRef.close()">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18"
          stroke="#667085"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 6L18 18"
          stroke="#667085"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </div>

  <mat-dialog-content>
    <div class="file-info-container">
      <div class="pdf-icon-wrapper">
        <div class="pdf-card">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M7 18H17V20H7V18Z" fill="#1570EF" />
            <path
              d="M19 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3ZM19 19H5V5H19V19Z"
              fill="#1570EF"
            />
            <path d="M7 7H17V9H7V7Z" fill="#1570EF" />
            <path d="M7 11H17V13H7V11Z" fill="#1570EF" />
          </svg>
          <span class="pdf-label">PDF</span>
        </div>
      </div>
      <div class="file-details">
        <div class="file-name">{{ fileName }}</div>
        @if (!isFast) {
          <div class="size-info">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11 7H12.5V12.25L17 14.92L16.25 16.15L11 13V7Z"
                fill="#667085"
              />
            </svg>
            <span
              >{{ downloadedSize || '0 KB' }} {{ 'COMMON.of' | translate }}
              {{ totalSize || '...' }}</span
            >
          </div>
        }
        @if (remainingTime) {
          <div class="time-info">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
                fill="#667085"
              />
              <path
                d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.15V7Z"
                fill="#667085"
              />
            </svg>
            <span
              >{{ 'NEW_WORDS.About' | translate }} {{ remainingTime }}
              {{ 'COMMON.remaining' | translate }}</span
            >
          </div>
        }
      </div>
    </div>

    <div class="progress-section">
      <div class="progress-labels">
        <span class="progress-title">
          {{ isFast ? ('Saving in process' | translate) : ('COMMON.Download Progress' | translate) }}
        </span>
        <span class="progress-percentage"
          >{{ progress | number: '1.0-0' }}%</span
        >
      </div>
      <div class="progress-bar-container">
        <div class="progress-bar-fill" [style.width.%]="progress"></div>
      </div>
    </div>

    <p class="footer-msg">
      {{
        isFast 
          ? ('Please keep this window open until the save is complete.' | translate)
          : ('COMMON.Please keep this window open until the download is complete.' | translate)
      }}
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button class="cancel-btn" (click)="cancelDownload()">
      {{ 'COMMON.Cancel' | translate }}
    </button>
  </mat-dialog-actions>
</div>
